import { render, staticRenderFns } from "./parametros.vue?vue&type=template&id=5ca3a66e"
import script from "./parametros.vue?vue&type=script&lang=js"
export * from "./parametros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports